import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { OverviewSectionLayout } from './OverviewSection/OverviewSectionLayout';
import { PersonalizedSectionLayout } from './PersonalizedSection/PersonalizedSectionLayout';
import { ExploreSectionLayout } from './ExploreSection/ExploreSectionLayout';

const LAYOUTS = {
  ProposalScenarioGoalStrategyDetailOverviewSection: OverviewSectionLayout,
  ProposalScenarioGoalStrategyDetailPersonalizedSection: PersonalizedSectionLayout,
  ProposalScenarioGoalStrategyDetailExploreSection: ExploreSectionLayout,
};

const getLayout = (type) => {
  const layout = LAYOUTS[type];
  if (!layout) {
    throw new Error(`Did not find a layout for resource type ${type}!`);
  }
  return layout;
};


export const GoalStrategyDetailsSections = ({ collection }) => {
  if (!collection) {
    return null;
  }
  return (
    <FDStack direction={'column'} spacing={6} paddingY={4} width={'100%'}>
      {collection.resources().list().map((section) => {
        const LayoutComponent = getLayout(section.type());
        return (
          <LayoutComponent resource={section} key={section.id()} />
        );
      })}
    </FDStack>
  );
};

GoalStrategyDetailsSections.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
